export const sidebarMenuList = [
  {
    id: 'detail-dasar',
    title: 'Detail Dasar',
    subtitle: 'Informasi Dasar SO',
  },
  {
    id: 'detail-produk',
    title: 'Detail Produk',
    subtitle: 'List produk yang akan dikirim',
  },
  {
    id: 'aktivitas-status-so',
    title: 'Aktivitas Status SO',
    subtitle: 'Riwayat perubahan status SO',
  },
  {
    id: 'aktivitas-staff',
    title: 'Aktivitas Staff',
    subtitle: 'Catatan aktivitas staff pada SO',
  },
]
